import {
  BulkJobStatusEnum,
  isBulkJobFinished,
  getBulkJobStatusColor,
  BULK_JOB_STATUS_COLORS
} from './bulkJobConstants'

export type { BulkJobStatusEnum }
export { isBulkJobFinished, getBulkJobStatusColor, BULK_JOB_STATUS_COLORS }

// Storage key for persisting read-only job ID across sessions
export const READ_ONLY_JOB_STORAGE_KEY = 'bulkReadOnlyJobId'

// Custom event name for job start notifications
export const READ_ONLY_JOB_STARTED_EVENT = 'bulkReadOnlyJobStarted'

// Polling interval in milliseconds for job status updates
export const READ_ONLY_POLLING_INTERVAL_MS = 1000

// Feature flag key for read-only plans for students
export const READ_ONLY_PLANS_FOR_STUDENTS_FEATURE = 'READ_ONLY_PLANS_FOR_STUDENTS'

// Type for custom event detail
export interface BulkReadOnlyJobStartedEventDetail {
  jobId: string
}
